import React, { useContext, useEffect, useMemo, useState } from 'react'

// Styles
import styles from './styles.module.scss'
import logoBlack from '@/img/logoBlack.png'

import { useForm } from 'react-hook-form'
import { FormHookProvider } from '@/components/moleculas'
import IconWithUnderline from '@/components/moleculas/IconWithUnderline/IconWithUnderline'
import { useRouter } from 'next/router'
import Image from 'next/image'
import { InputText } from '@/components/moleculas/InputText'
import { RecoverPasswordContext } from '@/context/guest/Login/RecoverPassword'
import Button from '@/components/moleculas/Button/Button'

export const RecoverPassword = () => {
  const { onSubmit } = useContext(RecoverPasswordContext)

  const [isEmailInput, setIsEmailInput] = useState(true)
  const [smallScreen, setSmallScreen] = useState(false)
  const router = useRouter()
  const methods = useForm()

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 768px)')
    const handleResize = () => mediaQuery.matches ? setSmallScreen(false) : setSmallScreen(true)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const inputTextEmail = useMemo(
    () => ({
      name: 'email',
      type: 'email',
      placeholder: 'ejemplo@correo.com',
      label: smallScreen ? 'Correo' : 'Para restablecer tu contraseña se envió un correo a:',
      variant: 'primary',
      height: '45px',
      rules: {
        required: 'El correo electrónico es requerido.',
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: 'Ingresa un correo electrónico válido.'
        }
      }
    }), [smallScreen])

  const inputTextPhone = useMemo(
    () => ({
      name: 'phone_number',
      placeholder: '33******06',
      label: smallScreen ? 'Teléfono' : 'Para restablecer tu contraseña se envió un sms a:',
      variant: 'primary',
      height: '45px',
      rules: {
        required: 'El teléfono es requerido.'
      }
    }), [smallScreen])

  return (
    <div className={styles.section}>
      <div className={styles.section_container}>
        <div className={styles.section_header}>
          <Image
            width={500}
            height={500}
            alt='general-configuration'
            src={logoBlack}
            className={styles.image}
            loading='lazy'
          />
        </div>
        <FormHookProvider methods={methods} method='POST' onSubmit={onSubmit.handleSendCode}>
          <h2 className={styles.title}>Recuperar Contrase&ntilde;a</h2>
          <h3 className={styles.text}>Recupera tu contrase&ntilde;a</h3>
          <div className={styles.iconsSection}>
            <span onClick={() => setIsEmailInput(true)}>
              <IconWithUnderline
                src='/img/icons/arrobaIcon.svg' width={150} height={150}
                alt='arroba-icon'
              />
            </span>
            <span onClick={() => setIsEmailInput(false)}>
              <IconWithUnderline
                src='/img/icons/phoneIcon.svg' width={150} height={150}
                alt='phone-icon'
              />
            </span>
          </div>
          {
            isEmailInput
              ? <InputText {...inputTextEmail} />
              : <InputText {...inputTextPhone} />
          }
          <div className={styles.form_button}>
            <div>
              <Button className='btn-black btn-md' onClick={() => router.push('/login')} label='Volver' type='button' />
            </div>
            <div>
              <Button className='btn-yellow btn-md' type='submit' label='Enviar código' />
            </div>
          </div>
        </FormHookProvider>
      </div>
    </div>
  )
}
